import {
    EDITCHARGEMASTER_SUCCESS,
    EDITCHARGEMASTER_FAILED,
    RESET_EDITCHARGEMASTER,
    LOADING_EDITCHARGEMASTER,
    NETWORK_ERROR_EDITCHARGEMASTER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_EDITCHARGEMASTER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case EDITCHARGEMASTER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case EDITCHARGEMASTER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_EDITCHARGEMASTER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_EDITCHARGEMASTER:
            return (state = initialState);
        default:
            return state;
    }
};
